import React from "react";
import {
  Alert,
  Box,
  Button,
  Container,
  Grid,
  Snackbar,
  Typography,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { useCategoryEditor } from "../../hook/useCategoryEditor";
import { CategoryForm } from "./CategoryForm";

export function CategoryView() {
  const { id } = useParams<{ id: string }>();
  const {
    category,
    setCategory,
    handleSave,
    validateField,
    showSnackbar,
    errors,
    setShowSnackbar,
    categoryIsValid,
  } = useCategoryEditor(id);
  return (
    <Box sx={{ width: "100%" }}>
      <Container sx={{ my: 5 }} maxWidth={"xl"}>
        {category?.name && (
          <Typography
            variant="h5"
            component="div"
            marginBottom={2}
            color="primary"
          >
            {category.name}
          </Typography>
        )}
        {!!category && (
          <CategoryForm
            setCategory={setCategory}
            category={category!}
            errors={errors}
            validateField={validateField}
          />
        )}
        {showSnackbar && (
          <Snackbar
            open={showSnackbar}
            autoHideDuration={6000}
            onClose={() => setShowSnackbar(false)}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert
              onClose={() => setShowSnackbar(false)}
              severity={categoryIsValid(errors) ? "success" : "error"}
              variant="filled"
            >
              {categoryIsValid(errors)
                ? "Enregistrement des données de l'utilisateur."
                : "Veuillez remplir tous les champs obligatoires."}
            </Alert>
          </Snackbar>
        )}
        <Grid
          container
          justifyContent="flex-end"
          sx={{
            position: "fixed",
            bottom: 50,
            left: -50,
            width: "100%",
          }}
        >
          <Button variant="contained" color="primary" onClick={handleSave}>
            Enregistrer
          </Button>
        </Grid>
      </Container>
    </Box>
  );
}
